import Router from 'next/router';
import CONFIG from 'config';

import axios from 'axios';
import { httpServiceTexts } from '@/assets/strings';
import { routeTexts } from '../../assets/strings/index';

const getToken = () => {
  if (document) {
    return localStorage.getItem('bp-token');
  }
};

const partnerInstance = axios.create();

partnerInstance.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      config.headers[httpServiceTexts.authorization] = token
        ? httpServiceTexts.bearer + token
        : null;
    }
    config.headers[httpServiceTexts.contentType] =
      httpServiceTexts.applicationJson;
    config.headers['X-UserType'] = 'partner';
    return config;
  },
  async (error) => {
    await (window as any).newrelic.noticeError(error);
    Promise.reject(error);
  }
);

partnerInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    if (error?.response?.status === 401) {
      Router.replace(`${routeTexts.login}`);

      (window as any).newrelic.noticeError(error);

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export const httpGet = <T>(url: string): Promise<T> => {
  return partnerInstance.get(CONFIG.URL.base + url);
};

export const httpPost = <T>(url: string, body: any): Promise<T> => {
  return partnerInstance.post(CONFIG.URL.base + url, body);
};

export const httpPut = <T>(url: string, body: any): Promise<T> => {
  return partnerInstance.put(CONFIG.URL.base + url, body);
};

export const httpDelete = <T>(url: string): Promise<T> => {
  return partnerInstance.delete(CONFIG.URL.base + url);
};
